import React from 'react'
import styled from '@emotion/styled'
import {theme} from '../../../theme'

const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2]};
  padding: ${theme.space[4]};
  border: 1px solid ${theme.colors.status.success.border};
  background: ${theme.colors.status.success.bg};
  border-radius: ${theme.radii.lg};
`

const SummaryTitle = styled.div`
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.primary};
`

const SummaryAddress = styled.div`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.text.secondary};
  line-height: 1.5;
`

// Read-only address recap for a location once the multi-location review flow
// has verified its address — replaces the full edit form so a resolved
// location doesn't keep inviting edits to fields that are already settled.
export function ResolvedLocationSummary({name, values = {}}) {
  const {address, city, state, postCode, country} = values
  const cityStateZip = [city, state].filter(Boolean).join(', ')

  return (
    <SummaryCard>
      {name && <SummaryTitle>{name}</SummaryTitle>}
      <SummaryAddress>
        {address && <div>{address}</div>}
        {(cityStateZip || postCode) && (
          <div>
            {cityStateZip}
            {postCode ? ` ${postCode}` : ''}
          </div>
        )}
        {country && <div>{country}</div>}
      </SummaryAddress>
    </SummaryCard>
  )
}
